// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"8":"b89bc144","194":"e7ea8c49","287":"a00dba33","405":"bce6b56d","408":"10242b3c","472":"1dc9f403","770":"60239186","797":"fe998a48","855":"b59807bf","961":"8c5ebf79"}[chunkId] + ".js";
};